import Breadcrumbs from "@/components/common/sections/Breadcrumbs";
import BreadcrumbsImage from "@/assets/images/breadcrumbs/IT-support.webp";

export default function AISolutionsPage() {
	return (
		<>
			<Breadcrumbs
				title="Log Ticket"
				subtitle=""
				breadcrumbText="Log Ticket"
				backgroundImage={BreadcrumbsImage}
			/>
		</>
	);
}